import { TimeOfClickActions } from 'src/pages/GlobalSetting/utils/types';

export enum RecipientGroupType {
  POLICY = 0,
  SYSTEM = 1,
}

export interface RecipientGroupsProps {
  id: string;
  recipientGroupName: string;
  emails: string[];
  isDefault: boolean;
  type: RecipientGroupType;
  recipientNumber: number;
  lastModified: string;
}

export interface ApprovedUsersProps {
  companyGuid: string;
  groupCompanyGuid: string;
  policyType: number;
  name: string;
  email: string;
}

export enum FileType {
  TXT = 'text/plain',
  CSV = 'text/csv',
  XML = 'text/xml',
}

export interface PLMExceptionProps {
  sha1: string;
  fileName: string;
  createdTime: string;
}

export interface AddPLMExceptionProps {
  fileSha1: string;
  fileName: string;
}

export interface DNSExceptionProps {
  users: string[];
}

export interface HighProfileUsersExceptionListProps {
  highProfileExceptionUserList: string[];
}

export interface HighProfileUsers {
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  orgId: string;
  category: string;
  wsTrainingStatus: boolean;
}

export interface HighProfileUsersDto {
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  orgId: string;
  category?: string;
}

export interface DeleteApprovedUsersDto {
  companyGuid: string;
  policyType: number;
  name: string;
  email: string;
}

export interface ApprovedHeaderFieldsProps {
  enableStatus: boolean;
  data: ApprovedHeaderFieldsItem[];
}

export interface ApprovedHeaderFieldsItem {
  key: string;
  operator: string;
  value: string;
}

export interface BlockListsProps {
  enabledStatus: boolean;
  data: BlockListsItem;
}

export interface BlockListsItem {
  senders: string[];
  file256Hashes: string[];
  urls: string[];
  fileHashes: string[];
}

export interface HighProfileDomainsProps {
  highProfileDomains: string[];
  highProfileExceptionDomains: string[];
  highProfileThreshold: number;
}

export interface DeleteHighProfileDomainsProps {
  highProfileDomains: string[];
  highProfileExceptionDomains: string[];
}

export enum GlobalSettingBlockListsCategories {
  SENDERS = 'senders',
  FILE256HASHES = 'file256Hashes',
  URLS = 'urls',
  FILEHASHES = 'fileHashes',
}

export interface CreateRecipientGroupReqDto {
  recipientGroupName: string;

  emails: string[];

  isDefault?: boolean;
}

export interface UpdateRecipientGroupReqDto {
  recipientGroupName?: string;
  emails?: string[];
}

export interface NotificationMailboxesResDto {
  companyId: string;
  tokenStatus: number;
  usableRange: number;
  mailbox: string;
}

export interface PasswordExtractionRulesProps {
  passwordExtractionEnable: boolean;
  passwordExtractionRules: PasswordExtractionRulesItem[];
}
export interface PasswordExtractionRulesLists {
  passwordExtractionRules: PasswordExtractionRulesItem[];
}
export interface PasswordExtractionRulesItem {
  itemKey: string;
  enableScan: boolean;
  prefix: string;
  matchPart: string;
  suffix: string;
  ignoreCase: boolean;
  regex: string;
}
export interface InputPasswordExtractionRulesLists {
  passwordExtractionRules: InputPasswordExtractionRulesItem[];
}

export interface InputPasswordExtractionRulesItem {
  itemKey: string;
  prefix: string;
  matchPart: string;
  suffix: string;
  ignoreCase: boolean;
}
export interface TestPasswordExtractionRulesLists {
  prefix: string;
  matchPart: string;
  suffix: string;
  ignoreCase: boolean;
  text: string;
}
export interface TimeOfClickStatusReqDto {
  dangerous: TimeOfClickActions;
  highlySuspicious: TimeOfClickActions;
  suspicious: TimeOfClickActions;
  untested: TimeOfClickActions;
}

export interface ExchangeInlineProtectionReqDto {
  ruleType: 'inbound' | 'outbound';
  enable: boolean;
}

export interface ConditionalAccessProps {
  policyName: string;
  action: string;
  users: {
    userId: string;
    userName: string;
    userPrincipalName: string;
  }[];
  id: string;
  [key: string]: any;
}

export interface ConditionalAccessSaveProps {
  policyName: string;
  action: string;
  [key: string]: any;
}

export interface ChangeUserConditionalAccessProps {
  sourcePolicyId?: string;
  targetPolicyId?: string;
}

export interface ConditionalAccessPolicy {
  policyName: string;
  enabled: boolean;
  action: 'mfa' | 'block';
  includeApp: 'office365' | 'all';
  isDefaultPolicy: boolean;
  id: string;
  users: {
    userId?: string;
    userPrincipalName: string;
    userName: string;
  }[];
  createAt: string;
  updateAt: string;
}

export interface UserInfo {
  userId?: string;
  userPrincipalName: string;
  userName: string;
}

export interface ConditionalAccessContextType {
  conditionalAccessOptions: {
    label: string;
    value: string;
  }[];
  policies: ConditionalAccessPolicy[];
  loading: boolean;
  getUserPolicy: (userPrincipalName: string) => string;
  updateUserPolicy: (
    userInfo: UserInfo,
    currentValue: string,
    newValue: string,
    currentPolicyId?: string
  ) => Promise<void>;
  refreshPolicies: () => Promise<void>;
  mipEnabled?: boolean;
}

export interface ConditionalAccessSelectorProps {
  userName: string;
  userPrincipalName: string;
  currentPolicyId?: string;
  currentPolicyValue: string;
  mipEnabled: boolean;
  dataSource: {
    cas?: boolean;
    v1?: boolean;
    mip?: boolean;
  };
  onPolicyChange?: (oldValue: string, newValue: string) => void;
}
